module.exports = __webpack_public_path__ + "static/img/13.aa32c5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/sp/13.png
// module id = 0a14
// module chunks = 0